// extracted by mini-css-extract-plugin
export var deliveryRow = "_o1-a";
export var fixedHeight = "_o1-4";
export var freightLogo = "_o1-9";
export var fullWidth = "_o1-3";
export var priceColumn = "_o1-5";
export var radioSelected = "_o1-7";
export var radioUnselected = "_o1-6";
export var selectedOption = "_o1-2";
export var selectedOptionContainer = "_o1-1";
export var selection = "_o1-0";
export var tallSkeletonText = "_o1-8";